import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

export const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToCalculator = () => {
    const element = document.getElementById('calculator');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-[#0A0A0A] pt-16" data-testid="hero-section">
      {/* Image - static, no effects */}
      <div className="w-full">
        <img
          src="https://customer-assets.emergentagent.com/job_dumitru-transport/artifacts/woxv3usu_13cb7a03-6acb-481f-8169-272b1a1ab620.jpeg"
          alt="Exclusive Tour Transfer Fleet"
          className="w-full object-contain"
        />
      </div>

      {/* Text below image */}
      <div className="bg-[#0A0A0A] px-4 py-8 text-center">
        <p className="uppercase text-xs tracking-[0.3em] text-[#D4AF37] mb-2">
          Premium Chauffeur Service
        </p>
        <h1 
          className="text-3xl sm:text-5xl font-light tracking-tight text-[#D4AF37] mb-2"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
          data-testid="hero-title"
        >
          {t('hero_title')}
        </h1>
        <p 
          className="text-base sm:text-xl text-[#D4AF37]/80 mb-3"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          {t('hero_subtitle')}
        </p>
        <p className="text-sm text-[#A1A1AA] max-w-xl mx-auto mb-6">
          {t('hero_description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/booking"
            className="w-full sm:w-auto px-8 py-3 bg-[#D4AF37] text-black font-semibold text-sm uppercase tracking-wider hover:bg-[#C5A059] transition-all duration-300 text-center"
            data-testid="hero-book-now"
          >
            {t('hero_cta')}
          </Link>
          <button
            onClick={scrollToCalculator}
            className="w-full sm:w-auto px-8 py-3 bg-transparent border border-white/20 text-white font-semibold text-sm uppercase tracking-wider hover:bg-white/5 hover:border-[#D4AF37] transition-all duration-300"
            data-testid="hero-calculate-price"
          >
            {t('hero_calculate')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
